import { useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";

export default function Settings() {
  const { user } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [busy, setBusy] = useState(false);

  const change = async () => {
    if (next.length < 6) { toast.error("New password must be 6+ chars"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password updated");
      setCurrent(""); setNext("");
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
    finally { setBusy(false); }
  };

  return (
    <div className="space-y-6 max-w-2xl" data-testid="settings-page">
      <div>
        <div className="text-[10px] uppercase tracking-[0.24em] text-slate-500">Account</div>
        <h1 className="mt-1 text-3xl font-medium tracking-tight" style={{ fontFamily: "'General Sans', system-ui, sans-serif" }}>Settings</h1>
      </div>

      <Card className="p-6">
        <div className="text-xs font-semibold uppercase tracking-[0.1em] text-slate-500 mb-4">Profile</div>
        <div className="space-y-3 text-sm">
          <div className="flex items-center justify-between"><span className="text-slate-500">Name</span><span>{user?.name}</span></div>
          <div className="flex items-center justify-between"><span className="text-slate-500">Email</span><span className="font-mono">{user?.email}</span></div>
          <div className="flex items-center justify-between"><span className="text-slate-500">Role</span><Badge variant="outline" className="capitalize">{user?.role}</Badge></div>
          {user?.area && <div className="flex items-center justify-between"><span className="text-slate-500">Area</span><span>{user.area}</span></div>}
        </div>
      </Card>

      <Card className="p-6">
        <div className="text-xs font-semibold uppercase tracking-[0.1em] text-slate-500 mb-4">Change password</div>
        <div className="space-y-3">
          <div>
            <Label>Current password</Label>
            <Input type="password" value={current} onChange={e=>setCurrent(e.target.value)} data-testid="settings-current-pw" />
          </div>
          <div>
            <Label>New password</Label>
            <Input type="password" value={next} onChange={e=>setNext(e.target.value)} data-testid="settings-new-pw" />
          </div>
          <Button onClick={change} disabled={busy || !current || !next} className="bg-[#0055FF] hover:bg-[#0044CC]" data-testid="settings-change-pw-btn">
            {busy ? "Saving..." : "Update password"}
          </Button>
        </div>
      </Card>
    </div>
  );
}
